'use strict';

var React = require('react');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');
var index = require('../Flex/index.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const hasIconWithoutText = (icon, children) => !!(icon && !children);
const iconSizeByButtonSize = {
    s: 's',
    m: 'm',
    l: 'm',
    xl: 'l',
};
const Button = React.forwardRef(({ iconPlacement = 'left', iconIntent, variant = 'primary', type = 'button', size = 'm', fullWidth = false, icon, children, active, ...props }, ref) => (React__default.default.createElement(styles.Styled.Button, { ...props, ref: ref, variant: variant, type: type, size: size, fullWidth: fullWidth, hasIconWithoutText: hasIconWithoutText(icon, children), active: active },
    React__default.default.createElement(index.Flex.Row, { space: "s", justifyContent: "center" },
        icon && iconPlacement === 'left' && React__default.default.createElement(component.Icon, { size: iconSizeByButtonSize[size], name: icon, intent: iconIntent }),
        children && React__default.default.createElement("span", null, children),
        icon && iconPlacement === 'right' && (React__default.default.createElement(component.Icon, { size: iconSizeByButtonSize[size], name: icon, intent: iconIntent }))))));

exports.Button = Button;
//# sourceMappingURL=component.js.map
